export default __webpack_public_path__ + "static/media/services_styling.48a7e5c9.jpg";